import { render } from "./AllCategoriesSection.vue?vue&type=template&id=12f5dbbe&scoped=true"
import script from "./AllCategoriesSection.vue?vue&type=script&lang=js"
export * from "./AllCategoriesSection.vue?vue&type=script&lang=js"

import "./AllCategoriesSection.vue?vue&type=style&index=0&id=12f5dbbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f5dbbe"]])

export default __exports__